"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const classNames = require("classnames");
const react_1 = require("react");
const classNames_1 = require("./classNames");
const tags_1 = require("./tags");
const tagDisplayName = (tag) => typeof tag === 'string' ? tag : tag.displayName || tag.name;
const createClassed = (tag) => {
    return (classes, ...placeholders) => {
        const Hoc = (props) => {
            const className = classNames(classNames_1.processClasses(classes, props, placeholders), props.className);
            const propsToForward = tags_1.filterPropsToForward(tag, props);
            return react_1.createElement(tag, Object.assign({}, propsToForward, { className }));
        };
        Hoc.displayName = `Classed(${tagDisplayName(tag)})`;
        return Hoc;
    };
};
tags_1.tags.forEach(tagName => {
    createClassed[tagName] = createClassed(tagName);
});
exports.classed = createClassed;
exports.default = exports.classed;
